import React, { lazy, Suspense, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';

const ChatWindow = lazy(() => import('./ChatWindow'));

export default function ChatBot() {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const { pathname } = useLocation();
  const sessionId = useMemo(() => `floating-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, []);
  if (pathname === '/yara') return null;
  const inline = pathname === '/order' || pathname === '/intake';
  return <>
    <aside className={`hbk-public-copy chat-launcher-hidable ${inline ? 'hbk-inline-support' : 'hbk-floating-support'}`} aria-label="Client support" data-testid="support-launcher">
      <button ref={triggerRef} className="hbk-support-button" onClick={() => setOpen(true)} aria-haspopup="dialog" data-testid="chatbot-toggle-btn"><MessageCircle size={20} aria-hidden="true" /> Ask Yara</button>
      <a href="tel:+12015353582" className="hbk-support-phone" data-testid="support-phone">Call (201) 535-3582</a>
    </aside>
    {open && <Suspense fallback={<p role="status" className="hbk-inline-support" data-testid="chat-loading">Loading Yara…</p>}><ChatWindow onClose={() => setOpen(false)} sessionId={sessionId} triggerRef={triggerRef} /></Suspense>}
  </>;
}